import { ChatHistory } from './../models/chat.model';
import { Injectable } from '@angular/core';
import { Chat } from '../models/chat.model';
import { Message } from '../models/message.model';
import { BackendApiService } from './backend-api.service';

@Injectable({
  providedIn: 'root',
})
export class SupportChatService {
  isChatVisible: boolean = false;
  chat?: Chat;
  ChatHistory?: ChatHistory

  constructor(private backendApiService: BackendApiService) {}

  init(clientName?: string) {
    this.chat = {
      owner: {
        id: 1,
        name: clientName ?? '',
      },
      recipient: undefined,
      history: [],
    };
  }

  sendMessage(message: Message) {
    console.log(message);

    this.backendApiService
      .sendSupportMessage(message.text)
      .subscribe((data) => {
        console.log(data);
        this.chat?.history.push(this.autoReply());
      });

    this.chat?.history.push(message);
  }

  autoReply(): Message {
    return {
      sender: {
        id: 0,
        name: 'Assistant',
      },
      text: 'We have received your message and will contact you shortly',
      time: new Date(),
    };
  }
}
